import { Button } from '@mui/material';
import React from 'react';
import '../style.css';
import { useNavigate } from 'react-router-dom';

const ManageLicensesPack = () =>
{
	const navigate = useNavigate();

	return (
		<><div className='flexRow pdngSM'>
			<div className='flexMinWidthCol'>
				<h2 className='uprCaseTxtMD pdngVtclSM'>License Name -&nbsp;<span className='lightTxt'> id</span></h2>
			</div>
			<div className='flexAutoRow'>
				<Button variant='outlined' color='primary' size='small' disableElevation disableRipple>Manage Licenses</Button>
			</div>
		</div><div className='flexColRow pdngHztlMD pdngBtmMD brdrBSM'>
			<div className='flexInline mrgnRSM'>
				<span className='reltvDateTxtSM pastTxt capitalTxt'>purchased :&nbsp;<span className='reltvDateTxtSMB'>02/03/2023</span></span>
			</div>
			<div className='flexInline'>
				<span className='reltvDateTxtSM featureTxt capitalTxt'>Expires:&nbsp;<span className='reltvDateTxtSMB'>02/03/2023</span></span>
			</div>
		</div><div className='resColRow pdngMD'>
			<div className='flexMinWidthCol'>
				<span className='reltvDateTxtSM capitalTxt'>products :&nbsp;<span className='reltvDateTxtSMB capitalTxt'>licenseType</span></span>
				<span className='reltvDateTxtSM capitalTxt'>license type :&nbsp;<span className='reltvDateTxtSMB capitalTxt'>Host</span></span>
				<span className='reltvDateTxtSM capitalTxt'>participants :&nbsp;<span className='reltvDateTxtSMB'>2</span></span>
			</div>
			<div className='flexAuto resPdngTop'>
				<Button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && navigate('/pricing'); }} fullWidth variant='contained' color='primary' disableElevation disableRipple size='small' className='whiteTxt' onClick={() => { navigate('/pricing'); }}> Buy license</Button>
			</div>
		</div>
		</>
	);
};

export default ManageLicensesPack;